/**
 * Shared app-shell layout metrics. Leaf module (no imports) so both the Topbar and the panels that
 * anchor to it (e.g. the Accounts panel's `insetTopPx`) can use the SAME height without an import
 * cycle. 48px per the 2026-07 Figma top-bar redesign (was 56px / `h-14`).
 */
export const TOPBAR_HEIGHT_PX = 48;

/**
 * Width of the right-side Accounts panel (`AccountsPanel` → `SlideOverPanel maxWidthPx`). Shared so
 * the panel and anything that must clear it while it's open (e.g. the topbar date-range popover
 * shifts left by this width) agree on one number.
 */
export const ACCOUNTS_PANEL_WIDTH_PX = 400;
